import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Calendar } from 'primereact/calendar';
import React, { useRef, useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import ictLogo from '../../assets/images/ICT-Logo-V4-1-1 1 (1).png';
import { Menu } from 'primereact/menu';
import { Paginator } from 'primereact/paginator';
import { Sidebar } from 'primereact/sidebar';
// import AddEditPermit from './AddEditPermit';
import { handleGetRequest } from '../../services/GetTemplate';
import { useDispatch } from 'react-redux';
import { ConfirmDialog } from 'primereact/confirmdialog';
import './PermitRenewalManagement.css';
import DeleteIcon from '../../assets/icons/delete.svg';
import { handleDeleteRequest } from '../../services/DeleteTemplate';
import { Tag } from 'primereact/tag';
import { useNavigate } from 'react-router-dom';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import ReactDOM from 'react-dom';
import PermitCertificate from '../../components/PermitCertificate';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import SuccessLoader from '../../components/SuccessLoader';
import RenewRoutePermit from './RenewRoutePermit';
import { handlePostRequest } from '../../services/PostTemplate';
import { Dropdown } from 'primereact/dropdown';

function PermitManagement() {
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(6);
    const [totalRecords, setTotalRecords] = useState(0);
    const [page, setPage] = useState(1);
    // const [sidebarVisible, setSidebarVisible] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    // const [editData, setEditData] = useState(null);
    // const [editAble, setEditAble] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
    const [userToDelete, setUserToDelete] = useState(null);
    const dispatch = useDispatch();
    const menuRefs = useRef(new Map());
    const certificateRef = useRef();
    const navigate = useNavigate();
    const [previewVisible, setPreviewVisible] = useState(false);
    const [selectedPermit, setSelectedPermit] = useState(null);
    const [showSuccess, setShowSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const toast = useRef(null);
    const [sidebarVisibleRenew, setSidebarVisibleRenew] = useState(false);
    const [renewData, setRenewData] = useState(null);
    const [globalFilter, setGlobalFilter] = useState('');
    const [searchFilters, setSearchFilters] = useState({
            vehicleNumber: '',
            cfxNumber: '',
            vehicleTypeId: null,
            startDate: null,
            endDate: null,
            permitNumber: '',
            paymentMethodId: null,
            requestStatusId: null,
        });
    const [vehivleList, setVehicleList] = useState();
    const [methodList, setMethodList] = useState();
    const [statusList, setStatusList] = useState();

    const roleName = localStorage.getItem('roleName');

    const handleDelete = async (row) => {
        setShowSuccess(true);
        try {
            const response = await dispatch(handleDeleteRequest(`/api/Request/Delete?id=${row.id}`, true, true));
            if (response?.success) {
                setDeleteDialogVisible(false);
                setUserToDelete(null);
                fetchPermitData(page);
            }
        } catch (error) {
            console.error('Error deleting user:', error);
        } finally {
            setShowSuccess(false);
        }
    };

    const fetchPermitData = async (pageNumber = 1) => {
        setLoading(true);
        try {
            const today = new Date();
            const currentDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
            
            
            const requestBody = {
                pageNumber: pageNumber,
                pageSize: rows,
                vehicleNumber: null,
                vehicleTypeId: null,
                paymentMethodId: null,
                permitNumber: null,
                cfxNumber: null,
                startDate: currentDate,
                endDate: currentDate,
                requestStatusId: null
            };

            const response = await dispatch(handlePostRequest(requestBody, '/api/permit/expire', false, false));
            if (response?.success) {
                setTableData(response?.data?.records || []);
                setTotalRecords(response?.data?.pagination?.totalRecords || 0);
            }
        } catch (error) {
            console.error('Error fetching permit data:', error);
        } finally {
            setLoading(false);
        }
    };
        const fetchPermitDataWithFilters = async (pageNumber = 1) => {
            setLoading(true);
            try {
                const formatDate = (date) => {
                    if (!date) return null;
                    if (typeof date === 'string') return date;
                    return date instanceof Date ? 
                        `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}` : 
                        null;
                };
                
                
                const today = new Date();
                const currentDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
                
                const DEFAULT_START_DATE = "2020-02-01";
                
                let startDate = searchFilters.startDate ? formatDate(searchFilters.startDate) : DEFAULT_START_DATE;
                let endDate = searchFilters.endDate ? formatDate(searchFilters.endDate) : currentDate;
                
                
               
                const requestBody = {
                    pageNumber: pageNumber,
                    pageSize: rows,
                    vehicleNumber: searchFilters.vehicleNumber && searchFilters.vehicleNumber.trim() !== '' ? searchFilters.vehicleNumber : null,
                    vehicleTypeId: searchFilters.vehicleTypeId === 0 ? 0 : (searchFilters.vehicleTypeId || null),
                    paymentMethodId: searchFilters.paymentMethodId === 0 ? 0 : (searchFilters.paymentMethodId || null),
                    permitNumber: searchFilters.permitNumber && searchFilters.permitNumber.trim() !== '' ? searchFilters.permitNumber : null,
                    cfxNumber: searchFilters.cfxNumber && searchFilters.cfxNumber.trim() !== '' ? searchFilters.cfxNumber : null,
                    startDate: startDate,
                    endDate: endDate,
                    requestStatusId: searchFilters.requestStatusId === 0 ? 0 : (searchFilters.requestStatusId || null)
                };
                
    
                const response = await dispatch(
                    handlePostRequest(
                        requestBody,
                        '/api/permit/expire',
                        false, 
                        false
                    )
                );
    
                if (response?.success) {
                    setTableData(response?.data?.records || []);
                    setTotalRecords(response?.data?.pagination?.totalRecords || 0);
                }
                if (response?.false) {
                    setTableData([]);
                    setTotalRecords(0);
                }
            } catch (error) {
                console.error('Error fetching permit data:', error);
            } finally {
                setLoading(false);
            }
        };

    const onPageChange = (event) => {
        const newPage = Math.floor(event.first / event.rows) + 1;
        setFirst(event.first);
        setRows(event.rows);
        setPage(newPage);
        
        // Check if any search filters are active
        const hasActiveFilters = Object.values(searchFilters).some(value => {
            // For date objects, check if they're not null
            if (value instanceof Date) return true;
            // For dropdown selected values that might be 0
            if (typeof value === 'number') return true;
            // For other values, check if they have content
            return value !== null && value !== undefined && value !== '';
        });
        
        
        // Use the appropriate fetch function based on whether filters are active
        if (hasActiveFilters) {
            fetchPermitDataWithFilters(newPage);
        } else {
            fetchPermitData(newPage);
        }
    };

   useEffect(() => {
           fetchPermitData(1);
           // eslint-disable-next-line react-hooks/exhaustive-deps
       }, []);

    // const handleEdit = (rowData) => {
    //     navigate(`/permit-requests/edit/${rowData.id}`);
    // };

    // const handleView = (rowData) => {
    //     navigate(`/permit-requests/view/${rowData.id}`);
    // };

    // const handleIssuePermit = (rowData) => {
    //     setSelectedPermit(rowData);
    //     setPreviewVisible(true);
    // };

    const handleRenew = (rowData) => {
        setRenewData(rowData);
        setSidebarVisibleRenew(true);
    };

    const handleDownloadPDF = async () => {
        try {
            await new Promise((resolve) => setTimeout(resolve, 1000));

            const canvas = await html2canvas(certificateRef.current, {
                scale: 2,
                useCORS: true,
                logging: false
            });

            const imgWidth = 210;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            const pdf = new jsPDF('p', 'mm', 'a4');
            const imgData = canvas.toDataURL('image/png');

            pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
            pdf.save(`permit-certificate-${selectedPermit.id}.pdf`);

            toast.current.show({
                severity: 'success',
                summary: 'Success',
                detail: 'Permit certificate downloaded successfully',
                life: 3000
            });

            setPreviewVisible(false);
        } catch (error) {
            console.error('Error generating PDF:', error);
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to generate PDF',
                life: 3000
            });
        }
    };

    const previewDialogFooter = (
        <div>
            <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={() => setPreviewVisible(false)} />
            <Button label="Download" icon="pi pi-download" onClick={handleDownloadPDF} />
        </div>
    );

    const actionBodyTemplate = (rowData) => {
        return (
            <Button
                disabled={rowData?.isRenewable === false}
                icon="pi pi-refresh"
                tooltip={rowData?.isRenewable === false && 'Fitness Expired'}
                className="p-button-xl p-button-rounded p-button-text p-button-info"
                onClick={() => handleRenew(rowData)}
                tooltipOptions={{ position: 'top' }}
            />
        );
    };

    const rowClassName = (rowData) => {
        return 'dataTableRow';
    };

    const template1 = {
        layout: 'CurrentPageReport',
        CurrentPageReport: (options) => {
            return (
                <span style={{ color: 'var(--text-color)', userSelect: 'none', textAlign: 'left', fontSize: '12px', fontWeight: '400' }}>
                    Showing{' '}
                    <span style={{ fontWeight: '700' }}>
                        {options.first} - {Math.min(options.first + options.rows - 1, options.totalRecords)}
                    </span>{' '}
                    from <span style={{ fontWeight: '700' }}>{options.totalRecords}</span> records
                </span>
            );
        }
    };

    const template2 = {
        layout: 'PrevPageLink PageLinks NextPageLink',
        PrevPageLink: (options) => {
            return <Button icon="pi pi-chevron-left" className="p-button prev-page-link" onClick={options.onClick} disabled={options.disabled} />;
        },
        PageLinks: (options) => {
            const isActive = options.currentPage === options.page;
            return (
                <button
                    type="button"
                    className={`mx-1 px-4 py-2 ${isActive ? 'isActivePage' : 'notActivePage'}`}
                    onClick={options.onClick}
                    style={{
                        width: '40.08px',
                        height: '40.08px',
                        fontSize: '14px',
                        fontWeight: '600',
                        borderRadius: '8px',
                        margin: '2px',
                        border: 'none',
                        boxShadow: isActive ? '0px 7px 16px 0px #00000024' : 'none'
                    }}
                >
                    {options.page + 1}
                </button>
            );
        },
        NextPageLink: (options) => {
            return <Button icon="pi pi-chevron-right" className="p-button-text prev-page-link" onClick={options.onClick} disabled={options.disabled} />;
        }
    };

    const onHideSidebar = () => {
        // setSidebarVisible(false);
        // setIsEditing(false);
        // setEditData(null);
        // setEditAble(false);
    };

    const getStatusSeverity = (status) => {
        switch (status) {
            case 'Pending':
                return 'info';
            case 'Approved':
                return 'success';
            case 'Rejected':
                return 'danger';
            case 'Completed':
                return 'warning';
            default:
                return 'info';
        }
    };

    const getPaymentStatusSeverity = (status) => {
        switch (status) {
            case 'Cash In Hand':
                return 'warning';
            case 'Paid By Client':
                return 'info';
            case 'Paid By Officer':
                return 'success';
            default:
                return 'info';
        }
    };

    const statusBodyTemplate = (rowData) => {
        return <Tag value={rowData.status} severity={getStatusSeverity(rowData.status)} />;
    };

    const paymentStatusBodyTemplate = (rowData) => {
        return <Tag value={rowData.paymentStatus} severity={getPaymentStatusSeverity(rowData.paymentStatus)} />;
    };

    const handleSearchFilterChange = (field, value) => {
        setSearchFilters((prev) => ({
            ...prev,
            [field]: value
        }));
    };
    const handleSearch = () => {
        setPage(1);
        setFirst(0);
        fetchPermitDataWithFilters(1);
    };

    const handleClearSearch = () => {
        setSearchFilters({
            vehicleNumber: null,
            cfxNumber: null,
            vehicleTypeId: null,
            startDate: null,
            endDate: null,
            permitNumber: null,
            vehicleTypeId: null,
            paymentMethodId: null,
            requestStatusId: null
        });
        setPage(1);
        setFirst(0);
        fetchPermitData(1);
    };

    const getLovsData = async () => {
        const vehiclesData = await handleGetRequest('/api/dropdown/vehicles', false);
        if (vehiclesData?.success) {
            setVehicleList(vehiclesData?.data);
        }
        const methodsData = await handleGetRequest('/api/dropdown/payment/method', false);
        if (methodsData?.success) {
            setMethodList(methodsData?.data);
        }
        const statusData = await handleGetRequest('/api/dropdown/request/status', false);
        if (statusData?.success) {
            setStatusList(statusData?.data);
        }
    };

    useEffect(() => {
        getLovsData();
    }, []);

    return (
        <>
            {showSuccess && <SuccessLoader />}
            <Toast ref={toast} />
            <ConfirmDialog
                visible={deleteDialogVisible}
                onHide={() => setDeleteDialogVisible(false)}
                message="Are you sure you want to delete this route permit request?"
                contentClassName="content-className"
                header="Delete Permit Request"
                headerClassName="text-black"
                icon={<img src={DeleteIcon} alt="Delete" />}
                acceptLabel="Sure"
                rejectLabel="Close"
                acceptClassName="accept-button"
                rejectClassName="reject-button"
                className="custom-confirm-dialog"
                accept={() => handleDelete(userToDelete)}
            />
            <Dialog header="Permit Certificate Preview" visible={previewVisible} style={{ width: '700px', maxWidth: '900px' }} onHide={() => setPreviewVisible(false)} footer={previewDialogFooter} maximizable>
                {selectedPermit && (
                    <div style={{ maxHeight: '70vh', overflow: 'auto' }}>
                        <PermitCertificate ref={certificateRef} data={selectedPermit} />
                    </div>
                )}
            </Dialog>
            <Sidebar visible={sidebarVisibleRenew} position="right" onHide={() => setSidebarVisibleRenew(false)} style={{ width: '30rem' }} showCloseIcon={false} blockScroll={true} className="renewal-sidebar">
                {renewData && <RenewRoutePermit onHideSidebar={() => setSidebarVisibleRenew(false)} rowData={renewData} fetchPermitsData={() => fetchPermitData(page)} />}
            </Sidebar>
            <div className="grid">
                <div className="col-12 flex flex-column">
                    <div className="flex justify-content-between items-center">
                        <h2 className="text-lg font-semibold">Permit Renewal Management</h2>
                        <div className="flex items-center gap-2">
                            {/* <span className="p-input-icon-left">
                                <i className="pi pi-search" />
                                <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." className="p-inputtext-sm rounded-input" />
                            </span> */}
                            {/* <span className="p-input-icon-right">
                                <i className="pi pi-search text-gray-600" />
                                <InputText className="Search__Input" placeholder="Search" />
                            </span> */}
                            {/* {roleName === 'Data Entry Operator' && (
                                <Button
                                    label="Add New"
                                    icon="pi pi-plus"
                                    className="px-4 py-2 font-semibold"
                                    style={{ backgroundColor: '#FF556A', border: 'none', borderRadius: '10px' }}
                                    onClick={() => {
                                        navigate('/permit-requests/add');
                                    }}
                                />
                            )} */}
                        </div>
                    </div>
                    <div className="mt-3 p-3 border-1 surface-border border-round">
                        <div className="grid">
                            <div className="col-12 md:col-3">
                                <span className="p-input-icon-left">
                                    <InputText id="vehicleNumber" value={searchFilters.vehicleNumber} onChange={(e) => handleSearchFilterChange('vehicleNumber', e.target.value)} placeholder="Enter vehicle number" className="Input__Round" />
                                </span>
                            </div>
                            <div className="col-12 md:col-3">
                                <span className="p-input-icon-left">
                                    <InputText id="cfxNumber" value={searchFilters.cfxNumber} onChange={(e) => handleSearchFilterChange('cfxNumber', e.target.value)} placeholder="Enter CFX number" className="Input__Round" />
                                </span>
                            </div>
                            <div className="col-12 md:col-3">
                                <span className="p-input-icon-left">
                                    <InputText
                                        id="permitNumber"
                                        name="permitNumber"
                                        value={searchFilters.permitNumber}
                                        onChange={(e) => handleSearchFilterChange('permitNumber', e.target.value)}
                                        placeholder="Enter permit number"
                                        className="Input__Round"
                                    />
                                </span>
                            </div>
                            <div className="col-12 md:col-3">
                                <span className="p-input-icon-left">
                                    <Dropdown
                                        options={vehivleList}
                                        optionValue="id"
                                        optionLabel="name"
                                        id="vehicleTypeId"
                                        name="vehicleTypeId"
                                        value={searchFilters.vehicleTypeId}
                                        onChange={(e) => handleSearchFilterChange('vehicleTypeId', e.target.value)}
                                        placeholder="Select Vehicle Category"
                                        className="Dropdown__Round w-full"
                                    />
                                </span>
                            </div>
                            <div className="col-12 md:col-3">
                                <span className="p-input-icon-left">
                                    <Dropdown
                                        options={methodList}
                                        optionValue="id"
                                        optionLabel="name"
                                        id="paymentMethodId"
                                        value={searchFilters.paymentMethodId}
                                        onChange={(e) => handleSearchFilterChange('paymentMethodId', e.target.value)}
                                        placeholder="Select Payment Method"
                                        className="Dropdown__Round w-full"
                                    />
                                </span>
                            </div>
                            <div className="col-12 md:col-3">
                                <span className="p-input-icon-left">
                                    <Dropdown
                                        options={statusList}
                                        optionValue="id"
                                        optionLabel="name"
                                        id="requestStatusId"
                                        value={searchFilters.requestStatusId}
                                        onChange={(e) => handleSearchFilterChange('requestStatusId', e.target.value)}
                                        placeholder="Select Status"
                                        className="Dropdown__Round w-full"
                                    />
                                </span>
                            </div>
                            <div className="col-12 md:col-3">
                                <Calendar
                                    id="startDate"
                                    name="startDate"
                                    placeholder="Select start date"
                                    dateFormat="mm/dd/yy"
                                    value={searchFilters.startDate}
                                    onChange={(e) => {
                                        handleSearchFilterChange('startDate', e.value);
                                        // If end date is before new start date, reset end date
                                        if (searchFilters.endDate && e.value && searchFilters.endDate < e.value) {
                                            handleSearchFilterChange('endDate', null);
                                        }
                                    }}
                                    inputClassName="Input__Round"
                                    // showIcon
                                />
                            </div>
                            <div className="col-12 md:col-3">
                                <Calendar
                                    id="endDate"
                                    name="endDate"
                                    placeholder="Select end date"
                                    dateFormat="mm/dd/yy"
                                    value={searchFilters.endDate}
                                    onChange={(e) => handleSearchFilterChange('endDate', e.value)}
                                    minDate={searchFilters.startDate || undefined}
                                    inputClassName="Input__Round"
                                />
                            </div>
                        </div>
                        <div className="flex justify-content-end gap-2 mt-3">
                            <Button label="Search" icon="pi pi-search" className="px-4 py-2 font-semibold" style={{ backgroundColor: '#ff556a', border: 'none', borderRadius: '10px' }} onClick={handleSearch} />
                            <Button label="Clear" icon="pi pi-times" className="px-4 py-2 font-semibold" style={{ borderRadius: '10px', backgroundColor: '#ff556a', border: 'none' }} onClick={handleClearSearch} />
                        </div>
                    </div>
                    <div className="card mt-3">
                        <DataTable
                            value={tableData}
                            loading={loading}
                            responsiveLayout="scroll"
                            className="datatable-responsive shadow-md rounded-xl"
                            scrollable
                            scrollHeight="45vh"
                            stickyHeader
                            emptyMessage={<div className="w-full text-center">No results found</div>}
                        >
                            <Column field="regNum" header="Reg No."  />
                            <Column field="vehicleType" header="Vehicle" />
                            <Column field="permitNum" header="Permit" />
                            <Column field="routeNumber" header="Route" />
                            <Column field="issueDate" header="Issue" />
                            <Column field="expDate" header="Expiry" />
                            <Column field="fitnessCFX" header="Fitness CFX" />
                            <Column field="fitnessExpiry" header="Fitness Exp" />
                            <Column header="Renew" body={actionBodyTemplate} style={{ width: '4rem' }} />
                        </DataTable>
                        <div className="flex justify-content-between mt-1" style={{ borderTop: '1px solid #efefef' }}>
                            <Paginator template={template1} first={first} rows={rows} totalRecords={totalRecords} onPageChange={onPageChange} currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" />
                            <Paginator template={template2} first={first} rows={rows} totalRecords={totalRecords} onPageChange={onPageChange} rowsPerPageOptions={[10, 25, 50]} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PermitManagement;
